import { render, staticRenderFns } from "./NhlNews.vue?vue&type=template&id=cbdcf5ca&scoped=true"
import script from "./NhlNews.vue?vue&type=script&lang=js"
export * from "./NhlNews.vue?vue&type=script&lang=js"
import style0 from "./NhlNews.vue?vue&type=style&index=0&id=cbdcf5ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdcf5ca",
  null
  
)

export default component.exports